import React from "react";
import { Provider } from "components/foreigner-personal/ForeignerPersonalContext";
import { ForeignerPersonalList } from "components/foreigner-personal/ForeignerPersonalList";

export const ForeignerPersonals = () => {
    return (
        <Provider>
            <ForeignerPersonalList />
        </Provider>
    );
};
